const Head = (props) => {
  return <>{props.children}</>;
};

Head.displayName = "PageHead";

export default Head;
